import actions from './actions'

const initialState = {
  ledgerList: [],
  ledgerItemsList: [],
  pagination: {},
  loading: false,
  ledgerItemDetail: {},
  detail: {},
}

export default function ledgerReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
